export const getAdvisorExternalUrl = (value: string) =>
	/^https?:\/\//i.test(value) ? value : `https://${value}`;
